/* eslint-disable max-len */
const translationMap = {
  titles: {
    default: 'Book With Resy',
    description: 'Discover restaurants to love in your city and beyond. Get the latest restaurant intel and explore Resy’s curated guides to find the right spot for any occasion. Book your table now through the Resy iOS or Android app, or on Resy.com.',
    all_restaurants: 'All Restaurants',
    restaurant_reservations: 'Restaurant Reservations',
    venue_details: 'Book Your {venueName} Reservation on Resy',
    venue_details_description: 'Book {venueName} in {marketCity} on Resy',
    event_details: 'Book Your {eventName} Event Reservation with {venueName} on Resy',
    reservation_details: 'Reservation Details',
    reservation_details_venue: '{venueName} Reservation Details',
    reservation_path_naa: 'Reservation Path NAA',
    login: 'Log in',
    signup: 'Sign up',
    add_payment: 'Add Payment',
    select_payment: 'Select Payment',
    reservation_confirmed: 'Reservation Confirmed',
    reservation_cancelled: 'Reservation Cancelled',
    profile: 'Profile',
    reservations_and_notify: 'Reservations & Notify',
    communication: 'Communication',
    manage_reservation: 'Manage Reservation',
    error: 'Page Not Found',
  },
  account: 'Account',
  add_card: 'Add Card',
  addon_enhance: 'Enhance Your Order',
  all: 'All',
  all_day: 'All Day',
  all_times: 'All Times',
  all_times_for_service: 'All times for {serviceTypeName}',
  allergies_placeholder: 'Add a note on allergies and restrictions…',
  allergy_note_disclosure_guest: 'We will share allergies, diet restrictions, or preferences you provide with our restaurants.',
  allergy_note_disclosure_party: 'We will share allergies, diet restrictions, or preferences you provide with the restaurant in advance of your reservation.',
  at_home: 'At Home',
  button_copied_bang: 'Copied!',
  edit_order: 'Edit Order',
  edit_reservation: 'Edit Reservation',
  events: 'Events',
  captcha_header: 'Security Check',
  captcha_subheader: 'Please complete this step to continue booking.',
  captcha_body: 'To help us maintain a fair experience for everyone, this step is required to book reservations at {venueName}.',
  captcha_verify_error: 'Please verify that you are not a robot.',
  card_verification_hold_message: 'To verify your card, our payment processor may place a temporary charge on your account, which will be released back to you within a few days.',
  add_eligible_card: 'Add Your Eligible Card',
  brand_icon: 'Resy and American Express logo',
  unlocking_animation: 'Unlocking animation',
  card_added_header: 'Card added',
  card_added_wait_message: 'It may take a few moments to add your Card information. Please try refreshing the page shortly.',
  gating_tooltip_content: 'Eligible American Express® Cards include The Platinum Card® from American Express Exclusively for Charles Schwab, Centurion® Card from American Express, Delta SkyMiles® Reserve American Express Card, Hilton Honors American Express Aspire Card, The Centurion® Card from American Express for Goldman Sachs, The Platinum Card®, The Platinum Card® from American Express Exclusively for Morgan Stanley, The Platinum Card® from American Express for Goldman Sachs, Business Centurion, Business Platinum Card®, Delta SkyMiles® Reserve Business American Express Card, Corporate Centurion Card and Corporate Platinum Card®.',
  generic_gating_header: 'Something went wrong',
  generic_gating_text: 'Please check your connection and try again. If you are still experiencing issues, please reach out to our customer support team at&nbsp;',
  hide_tool_tip: 'Hide Tooltip',
  show_tool_tip: 'Show Tooltip',
  close_profile_menu: 'Close profile menu',
  complete_your_order: 'Complete Your Order',
  concierge_booking: 'Concierge Booking',
  location: 'Location',
  add_gratuity: 'Add Gratuity',
  gratuity: 'Gratuity',
  order_summary: 'Order Summary',
  order_total: 'Order Total',
  platinum_eyebrow: 'For Platinum Card<sup>&reg;</sup> Members',
  pre_tax: '(pre-tax)',
  subtotal: 'Subtotal',
  tax: ' + tax',
  taxes_included: '(tax included)',
  taxes: 'Taxes',
  place_order: 'Place Order',
  reserve_now: 'Reserve Now',
  checkout: 'Checkout',
  rating_label: '{score} out of {scale} stars',
  remove_card_number_announcement: 'Remove {type} credit card number ending in {lastFour}',
  reset_password_header: 'Reset password',
  reset_password_body: 'You know the drill. Please start by providing the email address you used to register.',
  reset_password_success: "If a Resy account has been set up using this email address, you'll receive an email shortly.",
  set_password_success: 'Success. Your new password has been set.',
  new_password_body: 'Please select a new password and then type it again. That way you won’t forget it (again).',
  add_card_header: 'Add a credit card',
  confirmation_header: 'Order Confirmed.',
  confirmation_check_inbox: 'Please check your inbox for a confirmation email.',
  continue_to_reservation: 'Continue to Reservation Details',
  tabs_reservation_details: 'Reservation details',
  tabs_payment_details: 'Payment details',
  header_details: 'Details',
  confirmation_body_text: 'Please check your inbox for a confirmation email.',
  close: 'Close',
  clear_selected_add_ons: 'Clear selected add-ons',
  clear_selected_add_ons_for_category: 'Clear selected add-ons for {name}',
  close_payment: 'Close payment',
  button_submit: 'Submit',
  button_update: 'Update',
  select_more_guests: 'Select more guests',
  label_special_request: 'Add special requests',
  directions_link: 'Directions',
  download_native_app: 'Download Resy to access this reservation on your mobile device. Make changes, cancel, add special occasion and set up your dining profile.',
  download_our_app: 'Download our app',
  download_app_notify_message: 'Install the Resy app to receive Notify alerts and book reservations.',
  error_page: 'Sorry, but there seems to have been a problem. Please try reloading the page.',
  error_page_window: 'Sorry, but there seems to have been a problem.',
  window_close: 'Close this window.',
  invite_declined_header: 'Invite Cancelled',
  invite_declined_body: "Please <a href='mailto:help@resy.com'>email us</a> if you have questions.",
  login_explain: "Resy's hospitality platform manages your account securely. Please sign up or log in to complete your reservation.",
  login_header: 'Log in',
  button_login: 'Log in',
  label_email: 'Email',
  label_password: 'Password',
  number_guests: '{number} Guests',
  password_criteria_met: 'Met',
  password_criteria_not_met: 'Not Met',
  password_length: 'At least (8) characters',
  password_letter: 'At least (1) letter',
  password_number: 'At least (1) number',
  password_special_char: 'At least (1) symbol (!?$^& etc.)',
  per_ticket: 'per ticket',
  password_field_requirement: 'Password must be at least 6 characters',
  button_signup: 'Sign up',
  forgot_password_link: 'I forgot my password',
  back: 'Back',
  different_time_link: 'Choose a different time',
  tab_features: 'Features',
  tab_more_info: 'More Info',
  menu_highlights: 'Menu highlights',
  payment_information: 'Payment information',
  cancellation_policy_header: 'Cancellation policy',
  addons_header: 'Add ons',
  gratuity_header: 'Add gratuity',
  payment_method_header: 'Payment Method',
  venue_communication_opt_in: 'You consent to receive offers and marketing from this restaurant. You can withdraw consent at any time with the restaurant.',
  reservation_features_header: 'Included with your reservation',
  about_header: 'About',
  button_confirm: 'Confirm',
  legal_agreement: "By clicking \"Reserve Now\" you agree to Resy's {termsOfUse} and {privacyPolicy}.",
  legal_agreement_partner: "By clicking \"Reserve Now\" you agree to Resy's {termsOfUse} and {privacyPolicy} and Partner's {partnerTermsOfUse} and {partnerPrivacyPolicy}.",
  terms_of_use: 'Terms of Use',
  privacy_policy: 'Privacy Policy',
  select_payment_header: 'Select card',
  button_select_payment_submit: 'Select',
  signup_explain: 'This account works at any Resy restaurant and in the Resy app. Stay signed in for two-click reservations all over town.',
  signup_header: 'Create an account',
  label_given_name: 'First name',
  label_family_name: 'Last name',
  label_mobile_number: 'Mobile number',
  mobile_phone: 'Mobile Phone',
  field_helper_password: 'Password must be at least 6 characters',
  back_current_reservation_link: 'Back to Current Reservation',
  need_to_know_header: 'Need to Know',
  calendar_legend_available: 'Available',
  calendar_legend_unavailable: 'Unavailable',
  calendar_legend_sold_out: 'Sold Out',
  calendar_legend_closed: 'Closed',
  change_time: 'Change Time',
  next_online_availability_message: 'At the moment, there&apos;s no online availability for {selectedDateFormatted}. The next availability for {selectedQuantity} is&nbsp;',
  view_link: 'Click to view',
  view_menu: 'View Menu',
  no_availability_for_party_message: "Sorry, we don't currently have any tables available for {partySize}.",
  party_size: 'Party of {seats}',
  no_availability_message: "At the moment, there's no online availability for {selectedDate}.",
  button_add_notify: 'Notify',
  button_add_notify_venue_name: '{venueName}, Notify',
  button_place_notify: 'Notify',
  button_remove_notify: 'Notify On',
  button_remove_notify_venue_name: '{venueName}, Notify On',
  get_notified_if_tickets_become_available: 'Get notified if tickets become available.',
  set_a_notify_message: 'Set a notify so you don’t miss out.',
  cancel_confirmation_header: 'Cancelled',
  book_another: 'Book another table at {venueName}?',
  back_view_tables: 'Back to view tables',
  user_future_reservations: 'Upcoming Reservations',
  user_future_reservations_show_more: 'Show More Upcoming',
  user_past_reservations: 'Past Reservations',
  user_past_reservations_show_more: 'Show More Past',
  user_no_future_reservations: "You don't have any upcoming reservations.",
  tab_confirmation: 'Confirmation',
  special_request_header: 'Special Requests',
  edit_special_request: 'Edit special requests',
  button_cancel_reservation: 'Cancel Reservation',
  button_change_reservation: 'Change Reservation',
  button_invite_remove_self: 'Remove Myself',
  previous: 'Previous',
  next: 'Next',
  or: 'or',
  no_thanks: 'No Thanks',
  notify_breakfast: 'Notify for Breakfast',
  notify_brunch: 'Notify for Brunch',
  notify_dinner: 'Notify for Dinner',
  notify_lunch: 'Notify for Lunch',
  notify_remove_breakfast: 'Notify on for Breakfast, change or remove',
  notify_remove_brunch: 'Notify on for Brunch, change or remove',
  notify_remove_dinner: 'Notify on for Dinner, change or remove',
  notify_remove_lunch: 'Notify on for Lunch, change or remove',
  notify_table_chefs_list_title: 'When you didn’t get off the Notify list for {notifyVenueName}...',
  notify_set_confirmation_header: 'Notify Set',
  notify_set_confirmation_body: "Nice work. We'll be in touch.",
  notify_set_confirmation_close: 'Thanks!',
  notify_tables_available_header: 'Tables Available',
  notify_tables_available_close: 'View Now',
  notify_table_no_longer_available: 'Unfortunately, you didn\'t get this one, but you\'ll be notified if another table opens up.',
  notify_table_no_longer_available_default: 'It\'s not you -- {venueName} is in high demand. We\'ll keep you on the Notify list if another table opens up.',
  notify_table_no_longer_available_title: 'Table no longer available',
  notify_dialog_header: 'Set Notify',
  notify_dialog_body: 'If a table opens up, you will receive an email or push notification (if enabled).',
  notify_range_start_label: 'Preferred Start Time:',
  notify_range_end_label: 'End:',
  occasion: {
    Anniversary: 'Anniversary',
    Anniversary_selected: 'Anniversary selected',
    Birthday: 'Birthday',
    Birthday_selected: 'Birthday selected',
    Business: 'Business',
    Business_selected: 'Business selected',
    Graduation: 'Graduation',
    Graduation_selected: 'Graduation selected',
  },
  prepaid_card_error: 'Sorry, we can\'t accept prepaid cards. Please try another payment method.',
  button_notify_dialog_new: 'Set Notify',
  button_notify_dialog_cancel: 'Cancel Notify',
  button_notify_dialog_edit: 'Save Notify',
  remove_all: 'Remove All',
  remove_notify_for_date: 'Remove other Notify alerts for<br />{date}?',
  remove_notify_subtitle: 'Looks like you have other alerts set on the same day. Do you want to remove those and give others a chance?',
  removed: 'Removed',
  step_1: 'Browse',
  step_2: 'Details',
  step_3: 'Confirmation',
  notify_set_error: 'There was an error setting up your notification. Please try again.',
  add_card_required_cancellation: 'This reservation is free, but there may be cancellation fees if you cancel too late. A credit card is required to book.',
  add_card_required: 'This reservation is free, but the restaurant requires a credit card to book. Your information is being transmitted securely.',
  add_card_error_validation: 'Sorry. We could not validate your card. Please double check all fields.',
  add_card_error_generic: 'Sorry. There was a problem with your card. Please double check all fields.',
  captcha_required: 'Please complete the CAPTCHA before submitting.',
  remove_card_error_title: 'Unable to Remove Card',
  remove_card_reservation_error_subtitle: 'This card is required for a future reservation.',
  double_book_error: 'You already have a reservation on this day.',
  book_error_unavailable: 'The reservation you were trying to book is no longer available.',
  book_error_generic: 'There was a problem while trying to book this reservation.',
  special_request_success: 'Your request has been noted.',
  special_request_error: 'There was a problem adding your request. Please try again.',
  login_error: "We couldn't validate your login information. Please check that your email and password are correct.",
  generic_error: 'There was a problem. Please try again.',
  cancel_reservation_header: 'Cancel Reservation',
  abort_cancellation_button: 'Nevermind',
  abort_cancel_existing_reservation: 'Keep Existing Reservation',
  cancel_reservation_confirm_button: 'Yes, cancel',
  cancel_existing_reservation_message: 'You already have a <b>{serviceType}</b> reservation at <b>{venueName}</b>. Do you want to cancel that reservation and continue booking?',
  cancel_existing_reservation_confirm: 'Cancel that reservation and book this instead?',
  continue_button: 'Continue Booking',
  credit_card_label: 'Credit card ending in',
  card_ending_in: 'Card ending in {cardNumber}',
  credit_card_add_label: 'Add new card',
  button_add_card: 'Add card',
  reservation_details_not_found: 'This reservation is no longer available. Please try again!',
  reservation_details_error: 'Sorry. There was a problem retrieving that reservation. Please try again.',
  generic_submission_error: 'There was a problem processing your request. Please try again.',
  confirm_invite_decline_header: 'Cancel your invite?',
  confirm_invite_decline_message: 'You are about to leave this reservation, and may not be able to rejoin.',
  button_cancel: 'Cancel',
  button_ok: 'OK',
  button_done: 'Done',
  service_type_brunch: 'brunch',
  service_type_dinner: 'dinner',
  service_type_lunch: 'lunch',
  service_type_breakfast: 'breakfast',
  table_config_id_not_found: "We're sorry, the table you were looking for is no longer available. Please see below for our current availability.",
  timeslot_not_found: "Sorry we don't have any tables available {date} at {time}. Please see below for our current availability.",
  sign_out_link: 'Sign Out',
  cancel_reservation_confirm_message: 'Are you sure you want to cancel your reservation?',
  cancel_reservation_confirm_message_fee: 'Cancelling this reservation may trigger a fee of {amount} per guest. Are you sure you want to cancel your reservation?',
  cancel_reservation_confirm_message_credit: 'This reservation is no longer eligible for a refund, but your account will be credited for future use.',
  cancel_reservation_confirm_message_no_refund: "This reservation is no longer eligible for a refund, but you're doing the restaurant a solid by letting them know.",
  cancel_reservation_confirmation_message: 'Your reservation at {venueName} has been cancelled.',
  cancel_reservation_confirmation_message_thanks: 'Thanks for letting us know.',
  cancel_reservation_confirmation_message_refund: "You'll receive a refund shortly.",
  cancel_reservation_confirmation_message_credit: 'Your credit will be reflected in your account shortly.',
  change_past_cutoff: 'Your current reservation at {venueName} is past the cut-off time and cannot be changed.',
  close_notify_modal: 'Close Notify Modal',
  powered: 'Powered by',
  powered_by_resy: 'Powered by Resy',
  in_partnership_with: 'In Partnership With',
  footer_text: 'Resy powers some of the world\'s best restaurants, using technology to imagine the future of hospitality.',
  footer_text_secure: 'All transmission of personally identifiable information is via secure channels.',
  oai_gda_additional_access_copy: 'Global Dining Access Members may have access to additional reservations or experiences, available through <a href="https://resy.com/privacy" target="_blank">http://resy.com</a> or the Resy App.',
  tax_gratuity: ' + tax and fees',
  terms_accept: 'I have read and accept the <a href="https://resy.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://resy.com/terms/" target="_blank">Terms of Service</a>',
  marketing_accept: 'Receive curated recommendations for where to dine, including hit lists, chef interviews, and more.',
  marketing_accept_gdpr: 'Receive news and curated dining recommendations from Resy including Hit Lists, neighbourhood + cuisine guides, and chef interviews via email. All emails include an unsubscribe link. You can opt out at any time.',
  marketing_opt_in: 'Receive marketing emails',
  marketing_opt_in_disclaimer: 'You agree to the use of your data as described in our <a href="/privacy" target="_blank">Privacy Policy</a>. You may opt out of receiving marketing emails at any time.',
  marketing_opt_in_error_state_title_text: 'Failed to Submit. Try Again',
  marketing_opt_in_error_state_detail_text: 'There was an error submitting this request.',
  marketing_opt_in_subhead: 'Sign up for Resy emails to receive curated recommendations and insider tips on top restaurants in your area.',
  marketing_opt_in_terms: 'By leaving this toggle off you will be opted out of marketing emails, however, you will still receive communications regarding your bookings for Resy restaurants, events, and experiences.',
  marketing_opt_in_title: 'Discover Restaurants to Love',
  guest: 'Guest',
  guests: 'Guests',
  login: 'Log in',
  login_message: "Resy's hospitality platform manages your account securely. Please sign up or log in to complete your reservation.",
  forgot_password: 'Forgot password?',
  new_to_resy: 'New to Resy?',
  already_resy: 'Already have a Resy account?',
  create_an_account: 'Create an account',
  signup: 'Sign up',
  signout: 'Sign Out',
  birthday_note: 'Let restaurants know when you’re celebrating.',
  mobile_number_note: 'We will use only this number to confirm and manage your reservation.',
  allergies_and_restrictions: 'Allergies and Restrictions',
  allergies_note: 'Let the restaurant know in advance of any allergies or dietary restrictions.',
  communication_title: 'Communication',
  communication_heading: 'Manage Your Communication Preferences',
  communication_error_message: 'Error.',
  communication_loading_message: 'Loading...',
  communication_subheading: 'Opt in or out of email communications at any time. Resy only shares your information with restaurants you book, with your permission.',
  communication_heading_primary: 'Select Your Primary Dining City',
  communication_subheading_primary: 'Setting a primary dining city ensures we show you nearby restaurants and tailor suggestions to your city.',
  communication_heading_marketing: 'Sign Up for Resy Marketing Emails',
  communication_marketing_label: 'Get curated recommendations for where to dine, including The Resy Hit List, New on Resy, chef interviews, and more.',
  communication_heading_cities: 'Stay in the Restaurant Know',
  communication_save: 'Save',
  communication_other_section_title: 'Other Communications',
  communication_receive_rating_emails: 'Receive post-dining emails to provide feedback to restaurants.',
  contact_amex_to_book: 'Contact Amex to Book',
  country: 'Country',
  enter_missing_info: 'Please enter the following guest information for the reservation:\r{missingFields}',
  profile: 'Profile',
  profile_subtitle: 'We only share this information with restaurants you reserve, so they can coordinate with you and know your preferences.',
  profile_card_edit_profile: 'Edit Profile',
  profile_card_notify_win: 'Notify Win',
  profile_card_notify_wins: 'Notify Wins',
  profile_card_joined_resy: 'Joined Resy',
  first_name: 'First Name',
  last_name: 'Last Name',
  mobile_number: 'Mobile Number',
  mobile_number_success: 'Thanks, your phone number has been saved.',
  mobile_number_edit: 'Edit Mobile Number',
  mobile_number_new: 'Enter your new mobile number',
  mobile_number_desc: 'By providing your mobile number, you agree that it may be used to send you text messages and call you to confirm and manage your reservations.',
  mobile_number_verification_title: 'We sent you a code',
  mobile_number_verification_desc: 'We sent a 6-digit confirmation code to <span style="font-weight:bold; display:inline-block">{phoneNumber}</span>. Enter it here to verify your new number.',
  code_input_error: 'Oops, that didn’t work. Please enter the code that was sent to you.',
  otp_digit_number: 'Digit number {digitNumber} in OTP code',
  location_placeholder: 'Home ZIP, postal code, or city',
  email: 'Email',
  email_address: 'Email Address',
  password: 'Password',
  birthday: 'Birthday',
  month: 'Month',
  months: {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
  },
  day: 'Day',
  year: 'Year',
  next_month: 'Next month, {currentMonth} selected',
  prev_month: 'Previous month, {currentMonth} selected',
  short_bio: 'Short Bio',
  allergies: 'Allergies',
  restrictions: 'Restrictions',
  allergies_footnote: 'Resy shares provided allergy information with your restaurants to improve your dining experience.',
  save: 'Save',
  ok: 'OK',
  this_cannot_be_undone: 'This cannot be undone.',
  remove_stored_card_question: 'Remove Stored Card?',
  go_back: 'Go back',
  remove: 'Remove',
  default: 'Default',
  make_default: 'Make Default',
  concierge_registration_title: 'Concierge Registration',
  concierge_registered: 'You are registered as a concierge.',
  concierge_pending: 'Thanks! Our team will review your request and respond within 2 business days.',
  apply_here_link: 'Apply Here',
  company_name_input: 'Company name...',
  reason_for_requesting_input: 'Reason for requesting...',
  concierge_registration_intro: 'If you frequently book reservations on behalf of others, you can join our concierge program.',
  priority_notify: 'Priority Notify',
  profile_success: 'Thanks, your profile has been saved.',
  profile_success_email: 'Thanks, a confirmation email was sent to {email}.<br/><span style="font-weight:normal">Your email will not be changed until you confirm.</span>',
  errors: {
    birthday: {
      invalid: 'Please enter a valid birthday',
      incomplete: 'Please enter a complete birthday',
    },
    email: 'Please enter a valid email address',
    parse: {
      captcha: 'Please complete the captcha so we know you are not a robot.',
      login: "We couldn't validate your login information. Please check that your email and password are correct.",
      password: "The passwords you entered don't match. Please try again.",
      invalid: 'It looks like this password reset attempt has expired. Please try again.',
      inactive: 'Your account is no longer active. Please sign up for a new account.',
      try_again: 'Error. Please try again.',
      refresh: 'Error. Please refresh and try again.',
    },
    required: 'Please complete the required fields',
  },
  reservation: 'Reservation',
  reservations: 'Reservations',
  reservations_and_notify: 'Reservations & Notify',
  concierge_reservations: 'Concierge Reservations',
  no_upcoming_reservations: 'You don’t have any upcoming reservations.',
  no_reservations: 'You don’t have any past reservations.',
  upcoming_concierge_reservations: 'Upcoming Concierge Reservations',
  upcoming_reservations: 'Upcoming Reservations',
  upcoming_reservations_show_all: 'Show More Upcoming',
  past_reservations: 'Past Reservations',
  payment_methods_title: 'Payment Methods',
  no_payment_methods: 'You have no payment methods on file.',
  add_credit_card: 'Add Credit Card',
  resy_credit_banner_tagline_eligible: 'This venue currently qualifies for the Resy Credit, a benefit for select American Express® Card Members.',
  resy_credit_banner_tagline_eligible_temp_copy: 'Purchases made directly at this venue currently qualify for the Resy Credit, a benefit for select American Express® Card Members.',
  resy_logo: 'Resy logo',
  resy_logo_right_this_way: 'Resy logo, right this way',
  save_card: 'Save Card',
  saving_wait: 'Saving. Please wait...',
  select_city: 'Select a City',
  table_available_title: 'Tables Available at {notifyVenueName}',
  update_notify_modal_title: 'Update Notify',
  update_notify_modal_description: 'If a table opens up, you will receive an email or push notification (if enabled).',
  venue_support: 'Here is how you can support {venueName}:',
  whats_the_occasion: 'What\'s the occasion?',
  celebrating_special: 'Celebrating something special?',
  just_good_time: 'Just a good time',
  allergies_or_restrictions: 'Any allergies or restrictions?',
  question_selected_values_aria_label: '{header} Selected: {values}.',
  your_someone_in_party: 'Your own or someone in your party.',
  any_special_requests: 'Any special requests?',
  well_give_restaurants_heads_up: 'We\'ll give restaurants a heads up.',
  invite: 'Invite',
  invite_who_you_re_dining_with: 'Invite who you’re dining with',
  invite_who_you_re_dining_with_copy: 'Your guests can view the reservation, get updates, and share any dietary needs before you arrive.',
  close_invite_modal: 'Close invite modal',
  invite_your_party_title: 'Who\'s Joining?',
  invite_your_party_subtitle: 'Invite guests to add their dining preferences.',
  invite_your_party_subtitle_guest: 'Guests joining the reservation.',
  reservation_sheet_sms_message: 'Join my reservation for {venueName} for {reservationDate} at {reservationTime}',
  reservation_sheet_text_title: 'RSVP to {venueName} and add your dining preferences',
  reservation_sheet_title: 'RSVP at {venueName}',
  for_you: 'For You',
  your_party: 'Your Party',
  additional_dietary_note: 'Additional Dietary Note',
  none_continue: 'None, continue',
  add_note: 'Add an optional note on allergies and restrictions...',
  warning_leaving_resy: 'You are about to leave Resy\'s website.',
  onboarding: {
    title: '{venueName} uses Resy’s hospitality platform to securely manage your account information and reservations.',
    title_secondary: 'Resy’s hospitality platform securely manages your account information and reservations.',
    enter_number: 'Please enter your mobile phone number to verify or create an account:',
    enter_number_for_sign_up: 'To create an account, please enter your mobile number:',
    footnote: '{venueName} and Resy will only use this number to confirm and manage your reservation.',
    footnote_secondary: 'Resy will only use this number to confirm and manage your reservation.',
    use_email: 'Use Email and Password instead',
    code_title: 'Check your mobile phone!',
    code_copy_one: 'We sent a 6-digit confirmation code to ',
    code_copy_two: '. It expires shortly, so enter it soon.',
    code_copy_no_password: 'No need for a password.',
    need_help: 'Need Help?',
    help_title: 'How can we help?',
    resend_code: 'Resend Code',
    sign_in: 'Log in with email & password',
    sign_in_email_code: 'Log in with email & one-time code',
    create_account: 'Create account with email instead',
    create_account_with_phone: 'Create account with phone number instead',
    challenge_title: 'Hey {firstName}, is that you? ',
    challenge_copy: 'Please verify your account by entering the email address associated with the account:',
    not_first_name: 'Not {firstName}? ',
    create_new_account: 'Create a new account',
    please_log_in: 'Please log in:',
    no_account: 'Don’t have an account? ',
    password: 'Password',
    signup_title: 'Please create an account to continue.',
    signup_copy: 'Let’s get some basic information so that {venueName} knows who you are.',
    signup_copy_secondary: 'Let’s get some basic information so that restaurants know who you are.',

    continue: 'Continue',
    create_account_cta: 'Create Account',
    you_are_all_set: 'You are all set, {firstName}.',
    welcome_message: 'Welcome to Resy, {firstName}',
  },
  failed: 'Failed',
  help_and_feedback: 'Help & Feedback',
  set_card_as_default: 'Set card as default payment method',
  venue_about_header: 'About {venueName}',
  venue_credit_card_requirement: 'This venue requires a credit card to book because this reservation is either pre-paid, has pre-paid items, or may have a cancellation fee.',
  date_picker: 'Date Picker',
  please_try_adding_another_payment_method: 'Please try adding another payment method',
  this_card_could_not_be_added: 'This card could not be added',
  same_group_recommendations_eyebrow: 'From the {name} team',
  add_photo_cta: 'Add Photo',
  support_message: 'Still experiencing issues or have any questions? Please reach out to our customer support team at&nbsp;',
  gda_by_resy_logo: 'Global Dining Access by Resy logo',
  gda_priority_notify_icon: 'Priority notify icon',
  gda_exclusive_offer_icon: 'Exclusive reservations icon',
  gda_special_experience_icon: 'Special experiences icon',
  close_double_confirmation_booking_message: 'Close double confirmation booking message',
  verify_phone_aria_text: 'Verify phone number using one time code',
  help_aria_text: 'Help',
  verify_email_aria_text: 'Verify account by entering email address',
  login_aria_text: 'Login using email and password',
  phone_aria_text: 'Enter phone number',
  signup_aria_text: 'Sign up',
  email_code_aria_text: 'Verify email address using one time code',
  email_aria_text: 'Enter email address',
  success_view_aria_text: 'Login success',
  celebration_aria_text: 'Sign up success celebration',
  tock_reservations_notice_headline: 'Missing a Reservation?',
  tock_reservations_notice_body: 'If you booked through Tock, your reservation won\'t appear here. Check your confirmation email or manage your reservation directly on Tock.',
  tock_reservations_notice_link: 'Go to ExploreTock.com',
  tock_reservations_notice_badge: 'Now part of the Resy Network',
  maintenance_body_no_restore_time: 'As part of planned platform improvements, service is expected to be fully restored soon.',
  maintenance_body_with_restore_time: 'As part of planned platform improvements, service is expected to be fully restored by <strong>{restoreTime}</strong>.',
  maintenance_heading: 'Resy is currently undergoing scheduled maintenance.',
};

export default translationMap;
